<div class="container">
  <form [formGroup]="filterForm">
    <div class="form-row">
      <div class="col-md-4 mb-3">
        <label for="quickCardStatus">Status</label>
        <select id="quickCardStatus" class="form-control" formControlName="quickCardStatus">
          <option value="ALL" selected>ALL</option>
          <option value="ACTIVE">ACTIVE</option>
        </select>
      </div>
    </div>
  </form>
  <div class="quick-card-list mt-3 mb-3 table-responsive" *ngIf="quickCards.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th></th>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Days Total</th>
        <th class="text-center" scope="col">Days Used</th>
        <th class="text-center" scope="col">Days Remain</th>
        <th class="text-center" scope="col">Order Id</th>
        <th class="text-center" scope="col" *ngIf="isAdmin">User Id</th>
        <th class="text-center" scope="col" *ngIf="isAdmin">Firstname</th>
        <th class="text-center" scope="col" *ngIf="isAdmin">Lastname</th>
        <th class="text-center" scope="col" *ngIf="isAdmin">Email</th>
        <th class="text-center" scope="col">Start Date</th>
        <th class="text-center" scope="col">Expiration Date</th>
        <th class="text-center" scope="col">Is Active</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let quickCard of quickCards">
        <tr data-toggle="collapse" [attr.data-target]="'#row' + quickCard.id" class="accordion-toggle collapsed">
          <td class="expand-button"></td>
          <td class="text-center">{{ quickCard.id }}</td>
          <td class="text-center">{{ QuickCardValue[quickCard.value] }}</td>
          <td class="text-center">{{ quickCard.daysUsed }}</td>
          <td class="text-center">{{ QuickCardValue[quickCard.value] - quickCard.daysUsed }}</td>
          <td class="text-center">{{ quickCard.order.id }}</td>
          <td class="text-center" *ngIf="isAdmin">{{ quickCard.user.id }}</td>
          <td class="text-center" *ngIf="isAdmin">{{ quickCard.user.firstname }}</td>
          <td class="text-center" *ngIf="isAdmin">{{ quickCard.user.lastname }}</td>
          <td class="text-center" *ngIf="isAdmin">{{ quickCard.user.email }}</td>
          <td class="text-center">{{ quickCard.order.start| date:'dd.MM.yy HH:mm' }}</td>
          <td class="text-center">{{ quickCard.order.end | date:'dd.MM.yy HH:mm' }}</td>
          <td class="text-center">
            <span class="badge badge-pill badge-success" *ngIf="OrderStatus.READY === quickCard.order.status || OrderStatus.STARTED === quickCard.order.status">
              ACTIVE
            </span>
            <span class="badge badge-pill badge-danger" *ngIf="OrderStatus.READY != quickCard.order.status && OrderStatus.STARTED != quickCard.order.status">
              NOT ACTIVE
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="12" class="hiddenRow">
            <div class="accordion-body collapse" id="{{'row' + quickCard.id}}">
              QuickCard Visits:
              <table class="table table-striped">
                <thead>
                <tr>
                  <th class="text-center">#</th>
                  <th class="text-center">Time</th>
                  <th class="text-center">Event</th>
                  <th class="text-center">Door</th>
                  <th class="text-center">Card Number</th>
                  <th class="text-center">Day</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let visit of quickCard.visits">
                  <td class="text-center">{{ visit.id }}</td>
                  <td class="text-center">{{ visit.zkRtLog.time | date:'dd.MM.yy HH:mm:ss' }}</td>
                  <td class="text-center">{{ visit.zkRtLog.event }}</td>
                  <td class="text-center">{{ visit.zkRtLog.doorNumber }}</td>
                  <td class="text-center">{{ visit.zkRtLog.cardNumber }}</td>
                  <td class="text-center">{{ visit.day }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="quickCards.length == 0">
    <p>Here is no Quick Cards yet</p>
  </div>
</div>
